import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/index'
import solution from '../pages/solution'
import knowus from '../pages/knowus'
import mtsapi from '../pages/mtsapi'
import links from '../pages/links'
import ai from '../pages/ai'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: ''
      }
    },
    {
      path: '/solution',
      name: 'solution',
      component: solution,
      meta: {
        title: ''
      }
    },
    {
      path: '/knowus',
      name: 'knowus',
      component: knowus,
      meta: {
        title: ''
      }
    },
    {
      path: '/mtsapi',
      name: 'mtsapi',
      component: mtsapi,
      meta: {
        title: ''
      }
    },
    {
      path: '/links',
      name: 'links',
      component: links,
      meta: {
        title: ''
      }
    },
    {
      path: '/ai',
      name: 'ai',
      component: ai,
      meta: {
        title: 'AI查运费'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js